module.exports = __webpack_public_path__ + "img/sunny.18c0d136.svg";